import Vue from 'vue';
import Datepicker from 'vuejs-datepicker';
import { nl } from 'vuejs-datepicker/dist/locale';

Vue.component('documents-component', {
    components: {
        Datepicker,
    },

    /**
     * Vue.js instance reactive data variables.
     *
     * @return {Object}
     */
    data() {
        return {
            nl,
            showDocsFilter: false,
            filterString: 'Toon',
        };
    },

    /**
     * Called when the Vue.js instance is mounted and
     * ready for use.
     *
     * @return {void}
     */
    mounted() {

    },

    /**
     * Vue.js instance methods.
     *
     * @type {Object}
     */
    methods: {
        changeFormSelect(event) {
            const select = event.currentTarget;
            select.classList.remove('input-select--unselected');
            select.classList.add('input-select--selected');
        },

        toggleDocsFilter() {
            this.showDocsFilter = !this.showDocsFilter;

            if (this.showDocsFilter) {
                this.filterString = 'Verberg';
            } else {
                this.filterString = 'Toon';
            }
        },

        changeSorting(event) {
            const url = event.currentTarget.value;
            window.location = url;
        },
    },
});
